import React from 'react';

import { S3_BUCKET_URL } from '@/constants';
import { LAYOUT_NOTES } from '@/constants/campaign-notes';
import { ApiBotType } from '@/modules/api';
import { webCampaign } from '@/modules/webCampaign';

import { PhotosTileStyled } from './PhotoTile.styles';

export const PhotosTile: React.FC<{
  slicedAis: ApiBotType[][];
  gender?: 'male' | 'female' | null;
}> = ({ slicedAis, gender }) => {
  const layoutNotes = webCampaign.getLayoutNotes();
  const useStaticImage = layoutNotes.includes(LAYOUT_NOTES.EMAIL_STATIC_IMAGE);

  if (useStaticImage) {
    const staticImageSrc =
      gender === 'male'
        ? `${S3_BUCKET_URL}/layout-own-ai-man/sliced-twins.png`
        : `${S3_BUCKET_URL}/layout-own-ai/sliced_twins.png`;

    return (
      <PhotosTileStyled className="photos-tile static-mode">
        <div className="images-view">
          <img
            src={staticImageSrc}
            alt="AI characters"
            className="static-image"
          />
        </div>
      </PhotosTileStyled>
    );
  }

  return (
    <PhotosTileStyled className="photos-tile">
      <div className="images-view">
        {slicedAis.map((slicedAi, idx) => (
          <div className="images-view-line" key={idx}>
            {slicedAi.map((ai) => (
              <img src={ai.profile_picture_url} alt="AI" key={ai.id} />
            ))}
          </div>
        ))}
      </div>
    </PhotosTileStyled>
  );
};
